import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import ImageGallery from 'react-image-gallery';
import Header from '../components/Header';
import 'react-image-gallery/styles/css/image-gallery.css';

export default function ProjectDetail({ projects }) {
    const { projectId } = useParams();

    const [currentProject, setCurrentProject] = useState(null);
    const [showNav, setShowNav] = useState(false);

    useEffect(() => {
        if (projects.length > 0) {
            const project = projects.find(p => p.projectid === projectId);
            setCurrentProject(project);
        }

        // Check screen size for navigation
        if (window.innerWidth > 768) {
            setShowNav(true);
        } else {
            setShowNav(false);
        }

        // Listen for screen resizing
        const handleResize = () => {
            if (window.innerWidth > 768) {
                setShowNav(true);
            } else {
                setShowNav(false);
            }
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };

    }, [projectId, projects]);

    if (!currentProject) return null;
    console.log(currentProject.images.data)
    const imageSet = currentProject.images.data.map(img => ( {
        original: `https://schediopartners.com${img.attributes.url}`,
        thumbnail: `https://schediopartners.com${img.attributes.url}`,
        fallback: `https://schediopartners.com${img.attributes.url.replace('.jpg', '.png')}`
    }));


    function customRenderItem(item) {
        return (
            <div className='image-gallery-image'>
                <img
                    src={item.original}
                    alt="Gallery Image"
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = item.fallback;
                    }}
                />
                {
                    item.description &&
                    <span className='image-gallery-description'>
                        {item.description}
                    </span>
                }
            </div>
        );
    }

    const Arrow = ({ direction, onClick }) => {
        const rotation = direction === "left" ? "180deg" : "0deg";
        const position = direction === "left" ? "left-5" : "right-5"; // 5 units from the left or right

        return (
            <div className={`absolute top-1/2 transform -translate-y-1/2 ${position} z-10`}>
                <svg
                    onClick={onClick}
                    style={{
                        width: "44px",
                        height: "44px",
                        transform: `rotate(${rotation})`,
                        cursor: "pointer"
                    }}
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M9 18L15 12L9 6"
                        stroke="black"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </div>
        );
    };



    function CustomLeftNav(onClick) {
        return <Arrow direction="left" onClick={onClick} />;
    }

    function CustomRightNav(onClick) {
        return <Arrow direction="right" onClick={onClick} />;
    }

    return (
        <div className="pt-16 py-8 bg-e5dedb flex flex-col">
            <Header />
            <div className="flex-1/2 mb-8"> {/* Added height here */}
                <ImageGallery
                    items={imageSet}
                    showPlayButton={false}
                    showThumbnails={false}
                    showBullets={true}
                    showNav={showNav}
                    renderItem={customRenderItem}
                    renderLeftNav={CustomLeftNav}
                    renderRightNav={CustomRightNav}
                />
            </div>
            <div className="flex flex-col md:flex-row mx-6">
                <div className="w-full md:w-2/3 mb-4 md:mb-0">
                    <h2 className="text-xl font-bold mb-2">{currentProject.title}</h2>
                    <p className="text-sm text-gray-500 mb-4">{currentProject.location}</p>
                </div>
                <div className="w-full md:w-1/3">
                    <p className="text-justify">{currentProject.description}</p>
                </div>
            </div>
        </div>
    );

}
